import { render, staticRenderFns } from "./PlotBuffer.vue?vue&type=template&id=09974e38&scoped=true&"
import script from "./PlotBuffer.vue?vue&type=script&lang=js&"
export * from "./PlotBuffer.vue?vue&type=script&lang=js&"
import style0 from "./PlotBuffer.vue?vue&type=style&index=0&id=09974e38&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09974e38",
  null
  
)

export default component.exports